export default "__VITE_ASSET__DICncnps__"